import Api from "../..";
import { TransmedRegistrationFieldsInput } from "../../../dtos/transmed/process/registration/registration";

export default class TransmedRegistrationFieldsApi extends Api {
  constructor() {
    super("transmed/registration/fields");
  }

  public async post(data: TransmedRegistrationFieldsInput): Promise<void> {
    await super.post(data);
  }
}
